module.exports = __webpack_public_path__ + "static/img/product2-2.9d24359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product2-2.jpg
// module id = fpzs
// module chunks = 0